(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
    waitForEl(".junip-product-review-empty").then(() => {
      console.log("junip-product-review-empty");
      if(document.querySelector(".product-reviews") !== null) {
        document.querySelector(".product-reviews").style.display = "none"; 
      }
    });
  
  } catch(e) { console.error(e); }
})();
})();
